import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { Spin, Row, Col, Grid, Divider } from "antd";

import RegionalManagers from "./RegionalManagers";
import RegionName from "./RegionName";
import RegionMap from "./RegionMap";
import RegionHistory from "./RegionHistory";
import Clinics from "./clinics";
import Footer from "components/Footer";

import { fetchRegionData } from "utilities/redux/slices/regionSlice";
import { useDispatch, useSelector } from "react-redux";

const { useBreakpoint } = Grid;

const RegionDetails = () => {
  const dispatch = useDispatch();
  const screens = useBreakpoint();

  const region = useSelector((state) => state.selectedRegion.regionData);
  const regionStatus = useSelector((state) => state.selectedRegion.status);

  const { region_code } = useParams();

  useEffect(() => {
    dispatch(fetchRegionData(region_code));
  }, [region_code, dispatch]);

  if (!region || regionStatus === "loading") {
    return (
      <div className="flex justify-center items-center h-screen">
        <Spin />
      </div>
    );
  }

  const onChange = () => {
    dispatch(fetchRegionData(region_code));
  };

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        overflow: screens.xl ? "hidden" : "auto", // Allow vertical scrolling on mobile
        padding: 16,
      }}
    >
      {/* Region Name */}
      <Row style={{ marginBottom: 8 }}>
        <Col span={24}>
          <RegionName
            region={region}
            onChange={() => dispatch(fetchRegionData(region_code))}
          />
        </Col>
      </Row>
      <Divider style={{ margin: 8 }} />

      {/* Regional Managers */}
      <Row
        style={{ marginBottom: 8, wrap: true }}
        justify={screens.xl ? "space-between" : "start"} // On mobile, align content to start
        align="middle"
      >
        <Col
          span={24} // Full-width on mobile
          xl={18} // 20 span on xl and above
          style={{ marginBottom: screens.xl ? 0 : 8, wrap: true }} // Add spacing for mobile
        >
          <RegionalManagers region={region} onChange={onChange} />
        </Col>
        <Col
          span={24} // Full-width on mobile
          xl={4} // 4 span on xl and above
          style={{ textAlign: screens.xl ? "right" : "left" }} // Align to right on xl, left on mobile
        >
          <RegionHistory region={region} />
        </Col>
      </Row>

      {/* Main Layout */}
      <Row
        gutter={[16, 16]}
        style={{
          ...(screens.xl && {
            height: "calc(100vh - 300px)", // For desktop only
          }),
          // otherwise, height is auto
        }}
      >
        {screens.xl ? (
          // Desktop Layout
          <>
            <Col
              span={18}
              style={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                overflow: "hidden",
              }}
            >
              <RegionMap clinics={region.clinics} />
            </Col>
            <Col
              span={6}
              style={{
                height: "100%",
                maxHeight: "100%",
              }}
            >
              <Clinics region={region} />
            </Col>
          </>
        ) : (
          // Mobile Layout
          <>
            <Col
              span={24}
              style={{
                height: "800px",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <RegionMap clinics={region.clinics} />
            </Col>
            <Col
              span={24}
              style={{
                height: "100%",
                maxHeight: "100%",
              }}
            >
              <Clinics region={region} />
            </Col>
          </>
        )}
      </Row>
      <Footer />
    </div>
  );
};

export default RegionDetails;
